import useUiStore, { UiStoreState, UiStoreDispatch } from './ui';
import useUserStore, { UserStoreState, UserStoreDispatch, PrivilegesCache } from './user';
import useProductCache, { ProductCacheState } from './cache/product-cache';

export type UseStoreState = {
  ui: UiStoreState;
  user: Omit<UserStoreState, 'privilegesCache'>;
  productCache: ProductCacheState;
  userPrivilegesCache: PrivilegesCache;
};
export type UseStoreDispatch = UiStoreDispatch & UserStoreDispatch;
export type UseStore = [UseStoreState, UseStoreDispatch];

const useStore = (): UseStore => {
  const [uiState, uiDispatch] = useUiStore();
  const [
    { me, privilegesCache: userPrivilegesCache, ...computedHelpers },
    userDispatch
  ] = useUserStore();
  const [productCache] = useProductCache();

  return [
    {
      ui: uiState,
      user: { me, ...computedHelpers },
      productCache,
      userPrivilegesCache
    },
    {
      ...uiDispatch,
      ...userDispatch
    }
  ];
};

export default useStore;
